import { render, staticRenderFns } from "./AlbumLibrary.vue?vue&type=template&id=a4b0a334"
import script from "./AlbumLibrary.vue?vue&type=script&lang=js"
export * from "./AlbumLibrary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports